import { render, staticRenderFns } from "./TaskMap.vue?vue&type=template&id=36648e78&scoped=true"
import script from "./TaskMap.vue?vue&type=script&lang=js"
export * from "./TaskMap.vue?vue&type=script&lang=js"
import style0 from "./TaskMap.vue?vue&type=style&index=0&id=36648e78&prod&scoped=true&lang=css"
import style1 from "./TaskMap.vue?vue&type=style&index=1&id=36648e78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36648e78",
  null
  
)

export default component.exports